// Configuração vinda do build. Falha cedo e com mensagem clara: variável de
// ambiente faltando é o erro mais comum num deploy novo, e "supabaseUrl is
// required" no console não ajuda ninguém.

export interface Env {
  supabaseUrl: string;
  supabaseAnonKey: string;
  /** Carimbo do build. Aparece no rodapé e ajuda a saber o que está no ar. */
  buildId: string;
}

function obrigatoria(nome: string, valor: string | undefined): string {
  if (!valor || valor.trim() === '') {
    throw new Error(
      `Variável de ambiente ${nome} não está definida. ` +
        `Copie apps/web/.env.example para apps/web/.env e preencha com os dados ` +
        `do projeto Supabase (Settings → API).`,
    );
  }
  return valor.trim();
}

export const env: Env = {
  supabaseUrl: obrigatoria('VITE_SUPABASE_URL', import.meta.env['VITE_SUPABASE_URL']),
  supabaseAnonKey: obrigatoria('VITE_SUPABASE_ANON_KEY', import.meta.env['VITE_SUPABASE_ANON_KEY']),
  buildId: import.meta.env['VITE_BUILD_ID'] ?? 'dev',
};
